import { createAction, props } from '@ngrx/store';
import { ConfigurationScope } from '../configuration/configuration.models';
import {PoolScope, PoolsMenuScope, FantasyStats, SportsStats} from './pool.models';
import { HttpErrorState } from '../shared/error.models';

// pool item
export const callPool = createAction('[Pool] Call Pool',
    props<{
        id: number | string,
        shouldLoadStats?: boolean
    }>());

export const successPool = createAction('[Pool] Success Pool',
    props<{
        pool: PoolScope.CurrentPool
    }>());

export const initPoolSelections = createAction('[Pool] Init Selections Pool');
export const clearAllPoolSelections = createAction('[Pool] Clear All Selections');

export const toggleSelection = createAction('[Pool] Toggle Selection',
    props<{
        legId: number,
        bin: number,
        context?: string
    }>());

export const markSmartpick = createAction('[Pool] Generate Smartpick',
    props<{
        value?: number,
        context?: string
    }>()); // Client can be added

export const markCrossSell = createAction('[Pool] Generate Cross Sell',
    props<{
        cross_sell_suggestion?: any
    }>());

export const generateTicket = createAction('[Pool] Generate Ticket',
props<{
    selections: string,
}>());

export const clearCurrentLines = createAction('[Pool] Current Clear Lines');
export const removeSelectionsInLeg = createAction('[Pool] Current Clear Selections in Leg',
    props<{
      legId: number,
      context?: string
    }>());
export const removeLastSelectionInLeg = createAction('[Pool] Current Clear Last Selection in Leg',
    props<{
      legId: number,
      context?: string
    }>());

// pool featured
export const callPoolFeatured = createAction('[Pool] Call Featured');
export const successPoolFeatured = createAction('[Pool] Success Featured',
    props<{
        featuredPoolResponse: PoolScope.PoolFeatured
    }>());

export const clearPool = createAction('[Pool] Clear pool');

// pools list
export const callPoolsMenu = createAction('[Pools] Call Menu');
// pools headline
export const callPoolsHeadline = createAction('[Pools] Call Headline');
export const successPoolsHeadline = createAction('[Pools] Success Headline',
    props<{
        poolsHeadlineResponse: PoolsMenuScope.PoolHeadlineItem[],
        coreSettings: ConfigurationScope.coreSettings | undefined
    }>());

export const successPoolsMenu = createAction('[Pools] Menu Success',
    props<{
        parsedPoolsMenu: PoolsMenuScope.ParsedPoolsMenu
    }>());


export const successLeftMenu = createAction('[Pools] Left Menu Success',
  props<{
    parsedLeftMenu: any
  }>());

// TODO: check pooListMiddleware clearSportCode
export const setSportCode = createAction('[Pools] Set Sport Code',
    props<{
        sportCode: PoolsMenuScope.SportCode
    }>());

export const setPoolsExtraDetails = createAction('[Pools] Set PoolsExtra',
    props<{
        poolsExtraModel: PoolsMenuScope.PoolsExtraModel,
        filters: PoolsMenuScope.PoolFiltersByCategory
    }>());


export const partialUpdate = createAction('[Pools] Partial update / pool prize of Menu temporarily',
    props<{
        // TODO: Create discriminated union type for different websocket event data structures
        data: unknown,
        event?: string
    }>());

export const failPools = createAction('[Pools] Fail',
    props<{
        error: HttpErrorState
    }>());


// sport and fantasy stats actions

export const callSportsStats = createAction('[Pools] Call Sports stats',
  props<{
    poolId: number,
  }>());

export const successSportsStats = createAction('[Pool] Success sports stats',
  props<{
    stats: SportsStats[] | undefined
  }>());

export const callFantasyStats = createAction('[Pools] Call Fantasy stats',
  props<{
    poolId: number,
  }>())

export const successFantasyStats = createAction('[Pool] Success fantasy stats',
  props<{
    stats: FantasyStats[] | undefined
  }>());

// Loading state actions
export const setSportsStatsLoading = createAction(
  '[Pools] Set Sports Stats Loading',
  props<{ loading: boolean }>()
);

export const setFantasyStatsLoading = createAction(
  '[Pools] Set Fantasy Stats Loading',
  props<{ loading: boolean }>()
);
